<template lang="">
  <div class="app-create-new-ai-content__section">
    <div class="app-create-new-ai-content__section-header">
      <h4 class="app-create-new-ai-content__section-title">Basic details</h4>
      <p class="app-create-new-ai-content__section-instructions">Let us know what you're trying to build.</p>

      <app-error
        v-if="hasErrors"
        class="is--inline"
        v-bind="{ errors }" />
    </div>

    <form autocomplete="off" ref="inputFormBasicInfo">
      <div class="app-create-new-ai-content__section-body grid">
        <div class="col-12">
          <div class="input text">
            <label for="name">Title (required)</label>
            <input type="text" class="form-control" name="name" id="name" v-model="publicationData.name" required>
          </div>
        </div>
        <div class="col-12">
          <div class="input text">
            <label for="name">Course description</label>
            <textarea rows="8" class="form-control" name="description" id="description" :maxlength=editorMaxCharacterLimit_default v-model="publicationData.description"></textarea>
          </div>
          <p class="element-character-count">
            Character count: {{ getDescriptionCharacterCount }}
          </p>
        </div>
      </div>
      <div class="app-create-new-ai-content__section-footer">
        <app-button theme="primary" class="" @click="submitPublicationBasicData()" :disabled="disabledButton">
          {{ disabledButton ? 'Processing...' : 'Next: Describe Your Course' }}
        </app-button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'PublicationAiAppBasicDetails',
  props: {
    publication: {
      type: Object,
      required: true
    },
    subScreen: {
      type: String,
      required: true
    },
    editorMaxCharacterLimit_default: {
      type: Number,
      required: true
    },
    disabledButton: {
      type: Boolean,
      required: false,
      default: false
    },
    hasErrors: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    },
    errorMessage: {
      type: String,
      required: false,
      default: null
    },
    saveTrigger: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      publicationData: this.publication
    }
  },
  methods: {
    submitPublicationBasicData(menuSwap = null) {
      const formData = new FormData(this.$refs.inputFormBasicInfo)
      const params = Object.fromEntries(formData.entries());
      this.$emit('submissionOfData', { publication: this.publicationData, subScreen: 'details', params: params, menuSwap});
    }
  },
  computed: {
    getDescriptionCharacterCount() {
      return (this.publicationData.description?.length || 0) + '/' + this.editorMaxCharacterLimit_default;
    }
  },
  watch: {
    saveTrigger(newVal) {
      if (newVal) {
          this.submitPublicationBasicData('menuSwap');
      }
    }
  }
}
</script>